export const constants = {
  EMPTY_RESPONSIBLE_PERSON: "empty",
  ANY_RESPONSIBLE_PERSON: "[any]"
};
